import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import styles from './style.cssmodule.css';

function ParkingType({
  type, /* ASSIGNED | BOOKING | ON_DEMAND | REGULAR */
}) {
  const { formatMessage: t } = useIntl();

  let message = null;
  if (type === 'ASSIGNED') message = t({ id: 'parking.parkingType.assigned' });
  if (type === 'BOOKING') message = t({ id: 'parking.parkingType.booking' });
  if (type === 'ON_DEMAND') message = t({ id: 'parking.parkingType.on_demand' });
  if (type === 'REGULAR') message = t({ id: 'parking.parkingType.regular' });

  return (
    <div className={styles.container}>
      <div className={styles.badge} data-type={type}>
        <span>
          {message}
        </span>
      </div>
    </div>
  );
}

ParkingType.propTypes = {
  type: PropTypes.oneOf(['ASSIGNED', 'BOOKING', 'ON_DEMAND', 'REGULAR']),
};
ParkingType.defaultProps = {
  type: 'ASSIGNED',
};
ParkingType.displayName = 'ParkingType';

export default ParkingType;



// WEBPACK FOOTER //
// ./routes/cpm/routes/parkings/components/ParkingType/ParkingType.jsx